/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Proof_Quote2Inputs */

const en_funnel_ob_proof_quote2 = /** @type {(inputs: Funnel_Ob_Proof_Quote2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As someone with dyslexia, this gave me back reading. Honestly emotional the first time.`)
};

const es_funnel_ob_proof_quote2 = /** @type {(inputs: Funnel_Ob_Proof_Quote2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como persona con dislexia, esto me devolvió la lectura. La primera vez me emocionó de verdad.`)
};

/**
* | output |
* | --- |
* | "As someone with dyslexia, this gave me back reading. Honestly emotional the first time." |
*
* @param {Funnel_Ob_Proof_Quote2Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_proof_quote2 = /** @type {((inputs?: Funnel_Ob_Proof_Quote2Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Proof_Quote2Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_proof_quote2(inputs)
	return en_funnel_ob_proof_quote2(inputs)
});